export default "__VITE_ASSET__B86N9d5d__"